import { Dog, IDog, IProfile } from '@jumpstart/core';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { headerCase } from 'change-case';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { DOG_PROFILE_PLACEHOLDER, PROFILE_PLACEHOLDER } from '../../../../core/utils';
import { ISubscriber } from '../../schemas';

const Transition: any = forwardRef((props: any, ref: any) => <Slide direction="up" ref={ref} {...props} />);

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const styles = {
    root: {
      // overflow: 'hidden'
    },
    media: {
      height: 0,
      paddingTop: '56.25%' // 16:9
    },
    dialogRoot: {
      padding: 12,
      width: '100%',
      '& > *': {
        maxWidth: '550px'
      }
    },
  };

export interface IProfileInfoView {
  subscriber: ISubscriber | null;
  dog: IDog | null;
  profile: IProfile | null;
}

export default function ProfileInfoView(props: IProfileInfoView) {
  const { profile, dog, subscriber } = props;
  const [expanded, setExpanded] = useState(false);
  const [editing, setEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  if (!dog || !profile || !subscriber) {
    return null;
  }

  // const handleFormSubmit = async (data: UpdateData) => {
  //   console.log('SUBMIT', data);
  //   if (submitting) {
  //     return;
  //   }
  //   if (!profile || !dog) {
  //     console.error('Missing profile and/or dog data');
  //     return;
  //   }
  //   setSubmitting(true);
  //   const { firstName, ...dogData } = data;
  //   await updateDoc(doc(db, 'scout9-profiles', profile.id), {
  //     firstName: firstName ? firstName : ''
  //   });
  //   await updateDoc(doc(db, 'scout9-profiles', profile.id, 'dogs', 'default'), dogData);
  //   setSubmitting(false);
  //   setEditing(false);
  // };

  return (
    <Grid sx={styles.root} direction="column" container>
      <Dialog
        PaperProps={{ style: { height: '100%' } }}
        fullScreen
        TransitionComponent={Transition}
        keepMounted
        open={editing}
      >
        <DialogActions
          style={{ width: '100%', position: 'absolute' }}
        >
          <IconButton onClick={() => {
            setEditing(false);
          }}><CloseIcon/></IconButton>
        </DialogActions>
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={styles.dialogRoot}>
          <Typography color="error">@TODO add this form</Typography>
        </Grid>
      </Dialog>
      <Card style={{width: '100%'}}>
        <CardHeader
          avatar={
            <AvatarGroup>
              <Avatar
                alt={profile && profile.firstName ? profile.firstName : 'N/A'}
                src={profile && profile.img ? profile.img : PROFILE_PLACEHOLDER}
              />
              <Avatar
                alt={dog && dog.name ? dog.name : 'N/A'}
                src={dog && dog.img ? dog.img : DOG_PROFILE_PLACEHOLDER}
              />
            </AvatarGroup>
          }
          action={
            <IconButton aria-label="settings" onClick={() => {
              setEditing(true);
            }}>
              <MoreVertIcon/>
            </IconButton>
          }
          title={`${profile && profile.firstName ? profile.firstName : 'No Human Name'} & ${dog && dog.name ? dog.name : 'No Dog Name'}`}
          subheader={`Active since ${subscriber ? moment(subscriber.start)
            .format('MMMM Do YYYY') : ''} ${subscriber && subscriber.end ? '- ' + moment(subscriber.end)
            .format('MMMM Do YYYY') : ''}`}
        />
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            {subscriber && subscriber.testUser ? (<React.Fragment>Test User<br/></React.Fragment>) : ''}
            Phone: {subscriber && subscriber.phone ? subscriber.phone : 'N/A'}<br/>
            Email: {subscriber && subscriber.email ? subscriber.email : 'N/A'}<br/>
            Breed: {dog ? dog.breeds.map((b: string) => headerCase(b)).join(', ') : 'N/A'}<br/>
            Age: {dog ? Dog.ageFrom(dog.dob, 'months').toFixed(0) + ' months old' : ''} ({dog ? Dog.ageFrom(
            dog.dob,
            'days'
          ).toFixed(0) + ' days old' : ''})<br/>
            Gender: {dog && dog.gender ? dog.gender.toLowerCase() : 'N/A'}
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          {/*<IconButton aria-label="add to favorites">*/}
          {/*  <FavoriteIcon/>*/}
          {/*</IconButton>*/}
          {/*<IconButton aria-label="share">*/}
          {/*  <ShareIcon/>*/}
          {/*</IconButton>*/}
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {
            dog && profile ?
              <CardContent style={{ padding: 0 }}>
                <JSONInput
                  id=''
                  placeholder={{ dog: dog, profile: profile }}
                  // colors      = { darktheme }
                  locale={locale}
                  height='380px'
                />

              </CardContent>
              : null
          }
        </Collapse>
      </Card>
    </Grid>
  );
}
